module.exports = __webpack_public_path__ + "static/Divya.4d7d6e8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Divya.jpg
// module id = 1297
// module chunks = 137408898365125